import React, { Component } from 'react'
import { translate, Trans } from 'react-i18next'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'

import './Terms.css'
import QbButton from '../shared/QbButton/QbButton'
import { POLICY_STOARGE_FUNCTIONS } from '../../store/actions/auth'
import { QbOutsideLink } from '../shared/QbLink/QbLink'
import { TERMS_AND_CONDITIONS_URL, PRIVACY_POLICY_URL } from '../../constants/constants'
import QbCheckbox from '../shared/QbCheckbox/QbCheckbox'
import { WARNING_COLOR } from '../../constants/style'

class Terms extends Component {  

  render() {
    const { t } = this.props
    return (
      <div className="terms-container">        
        <h1 style={HEADER_STYLE}> {t('tc-policy.title')} </h1>
        <p style={TEXT}>
          <Trans i18nKey="tc-policy.text">
            We have updated the qiibee web wallet <QbOutsideLink to={TERMS_AND_CONDITIONS_URL}>terms and conditions</QbOutsideLink>. To continue to use the wallet, you must read and accept them.
          </Trans>
        </p>
        <QbButton style={BUTTON_STYLE} name={t('tc-policy.button')} onClick={this.props.acceptTCPolicy} />
      </div>
    )
  }
}

const mapDispatchToProps = dispatch =>
  bindActionCreators({
    ...POLICY_STOARGE_FUNCTIONS,
}, dispatch)

export default connect(null, mapDispatchToProps)(translate()(Terms))

const HEADER_STYLE = {
  fontWeight: 600,
  lineHeight: '27px',
  fontSize: '20px'
}

const BUTTON_STYLE = {
  width: '100%'
}

const TEXT = {
  fontSize: '14px',
  fontWeight: 'normal',
  lineHeight: '20px'
}

export const TermsBox = ({ checkboxSelected, onCheckboxClick, checkboxError }) => (
  <div className="create-wallet-terms" style={getWarningStyle(checkboxError)}>
    <QbCheckbox checked={checkboxSelected} onChange={onCheckboxClick} />
    <div>
      <Trans i18nKey="tc-policy.text-2">
        I agree to the <QbOutsideLink style={getWarningStyle(checkboxError)} to={TERMS_AND_CONDITIONS_URL}> terms and conditions </QbOutsideLink>. and have read the <QbOutsideLink style={getWarningStyle(checkboxError)}  to={PRIVACY_POLICY_URL}> privacy policy.</QbOutsideLink>
      </Trans>
    </div>
  </div>
)

function getWarningStyle(error) {
  return error ? {color: WARNING_COLOR} : {}
}


// WEBPACK FOOTER //
// ./src/components/Terms/Terms.js